import { UserSupportedLanguageType } from "@whatslly/types/User";

export const VALID_LANGS = ["ENGLISH", "SPANISH", "PORTUGUESE"];

export const getI18nLanguageFromUserSetting = (lang?: UserSupportedLanguageType) => {
  if (lang === "ENGLISH") return "en";
  if (lang === "SPANISH") return "es";
  if (lang === "PORTUGUESE") return "pt";
  return "en";
};

export const getUserSettingLanguageFromI18n = (lang?: string) => {
  if (lang === "en") return "ENGLISH";
  if (lang === "es") return "SPANISH";
  if (lang === "pt") return "PORTUGUESE";
  return "ENGLISH";
};
